import React from "react";
import Reveal from "./Reveal";

const steps = [
  {
    idx: "01",
    title: "Share requirements",
    desc: "Tell us your topic, university, deadline, and which services you need.",
  },
  {
    idx: "02",
    title: "Free consultation",
    desc: "Our experts review your needs and map out a custom research roadmap.",
  },
  {
    idx: "03",
    title: "Work begins",
    desc: "Your assigned PhD expert starts working, with regular progress updates.",
  },
  {
    idx: "04",
    title: "Submit & succeed",
    desc: "Receive polished, submission-ready work. Revisions included.",
  },
];

export default function Process() {
  return (
    <section id="process">
      <div className="wrap">
        <Reveal className="section-head">
          <div className="eyebrow">How It Works</div>
          <h2>Simple 4-step process</h2>
          <p>Get started in minutes — our streamlined process gets you expert support fast.</p>
        </Reveal>

        <div className="process-grid">
          {steps.map((s) => (
            <Reveal as="div" className="step" key={s.idx}>
              <span className="idx">{s.idx}</span>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
